import React from "react";
import Chart from "react-apexcharts";
import { colors } from "../../global";

const fmtCurrency = (n) =>
  typeof n === "number"
    ? n.toLocaleString(undefined, { style: "currency", currency: "AUD" })
    : "—";

export default function SummaryTop10LanesChart({
  data,
  title = "Summary of Top 10 Lanes by Spend",
}) {
  data = [
    { Cora_Lane: "BNE-BNE", cons: 92, Spend: 5200 },
    { Cora_Lane: "BNE-MCE", cons: 78, Spend: 2100 },
    { Cora_Lane: "0-0", cons: 30, Spend: 1200 },
    { Cora_Lane: "BNE-MEL", cons: 80, Spend: 2600 },
    { Cora_Lane: "BNE-SYD", cons: 55, Spend: 4100 },
    { Cora_Lane: "BNE-VC3", cons: 85, Spend: 1700 },
    { Cora_Lane: "400-502", cons: 28, Spend: 900 },
    { Cora_Lane: "BNE-TAS", cons: 26, Spend: 1800 },
    { Cora_Lane: "BNE-PTH", cons: 15, Spend: 1400 },
    { Cora_Lane: "TBR-NB", cons: 12, Spend: 1200 },
  ];
  const categories = data.map((d) => d.Cora_Lane);
  const cons = data.map((d) => d.cons || 0);
  const spend = data.map((d) => d.Spend || 0);

  const options = {
    chart: {
      stacked: false,
      toolbar: { show: false },
      fontFamily:
        "ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial",
    },
    colors: [colors.primary, colors.accent],
    title: {
      text: title,
      style: { fontWeight: 600, color: "#1f2937" },
      align: "center",
    },
    legend: {
      position: "top",
      horizontalAlign: "center",
      labels: { colors: "#374151" },
    },
    plotOptions: {
      bar: { columnWidth: "45%", borderRadius: 6 },
    },
    dataLabels: { enabled: false },
    stroke: { width: [0, 3], curve: "smooth" },
    markers: { size: 3 },
    xaxis: {
      categories,
      labels: {
        rotate: -25,
        style: { colors: Array(categories.length).fill("#374151") },
      },
      axisBorder: { color: colors.gray },
      axisTicks: { color: colors.gray },
    },
    yaxis: [
      {
        // Left: # cons
        title: {
          text: "# cons",
          style: { color: colors.primary, fontWeight: 600 },
        },
        labels: { style: { colors: [colors.primary] } },
        decimalsInFloat: 0,
        min: 0,
      },
      {
        // Right: Spend ($)
        opposite: true,
        title: {
          text: "Spend",
          style: { color: colors.accent, fontWeight: 600 },
        },
        labels: {
          formatter: (val) => fmtCurrency(val),
          style: { colors: [colors.accent] },
        },
        min: 0,
      },
    ],
    tooltip: {
      shared: true,
      intersect: false,
      y: [
        { formatter: (val) => (val == null ? "—" : `${Math.round(val)}`) },
        { formatter: (val) => (val == null ? "—" : fmtCurrency(val)) },
      ],
    },
    grid: {
      strokeDashArray: 4,
      borderColor: "#e5e7eb",
      xaxis: { lines: { show: false } },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          xaxis: { labels: { rotate: -35 } },
          plotOptions: { bar: { columnWidth: "55%" } },
        },
      },
    ],
  };

  const series = [
    { name: "# cons", type: "column", data: cons },
    { name: "Spend", type: "line", data: spend },
  ];

  return <Chart options={options} series={series} type="line" height={360} />;
}
